import { NotificationsCard } from '@folio/components';
import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { useTranslation } from 'react-i18next';

export function NotificationsModule() {
  const { t } = useTranslation();
  const { policy } = usePolicyOnDashboard();

  return ['POLICY_CREATED', 'POLICY_QUOTED'].includes(policy.status) ? (
    <div className="text-center text-sm text-gray-500">{t('notifications.empty')}</div>
  ) : (
    <NotificationsCard policyId={policy.id} productId={policy.productId} />
  );
}
